import { useMutation, useQueryClient } from 'react-query';
import { useModal } from 'store/modals';
import { getTenantIDBasedOnURL } from 'global/tenant-config';
import { GET_PAIRING_STATUS } from '../get-pairing-status';
import { startPairingStatusAPI } from './api';

export function useStartPairing(user) {

  const queryClient = useQueryClient();
  const tenantId = getTenantIDBasedOnURL();
  const { openModal } = useModal();

  const { mutateAsync, mutate, data, isLoading, isSuccess, isError } = useMutation(
    () => startPairingStatusAPI(user?.Id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([GET_PAIRING_STATUS, tenantId, user?.Account?.Email]);
        openModal({
          modalType: 'NotificationModal',
          modalProps: {
            type: 'success',
            description: 'pairingProcessStarted',
          },
        });
      },
      onError: (error) => {
        if (error.errorMessage === 'No pairing devices available for this user') {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'noPairingDevicesErrorMessage',
            },
          });
        } else {
          openModal({
            modalType: 'NotificationModal',
            modalProps: {
              type: 'error',
              description: 'genericErrorMessage',
            },
          });
        }
      },
      enabled: !!user?.Id,
    },
  );

  return {
    mutateAsync,
    mutate,
    code: data?.pin,
    validNumberOfDays: data?.validUntil,
    isLoading,
    isSuccess,
    isError,
  };
}

